<mat-accordion>
  <ng-content></ng-content>
</mat-accordion>
